import { createEl, replaceUrl, parseCookies } from "./utils.js"
import snackbar from "./snackbar.js";

let root = null;

function login() {
    const [el, refs] = createEl();

    const container = el("main", { class: "login-container" }, [
        el("div", { class: "login-form" }, [
            el("h1", "IF Room Reservation"),
            el("div", [
                el("button", { ref: "loginButton" }, "Log in with Unpar account"),
            ]),
        ]),
    ]);

    refs.loginButton.addEventListener("click", () => {
        window.location.href = "/auth/google";
    });

    return container;
}

export default () => {
    const cookies = parseCookies(document.cookie);

    if(typeof cookies.userId !== "undefined") {
        replaceUrl("/");
        return "";
    }

    if(root === null) {
        root = login();
    }

    const url = new URL(window.location.href);
    if(url.searchParams.has("auth_error_code")) {
        const errorCode = url.searchParams.get("auth_error_code");
        switch(errorCode) {
            case "unknown-1":
                snackbar.dispatch("Error: oauth2 authenticator refusing request", "error");
                break;
            case "unknown-2":
                snackbar.dispatch("Error: the oauth2 authenticator rejected our request to authenticate you", "error");
                break;
            case "unknown-3":
                snackbar.dispatch("Error: unknown error, could be a server, or network issue", "error");
                break;
            case "not-registered":
                snackbar.dispatch("Error: you're not registered in the system, contact the administrator if you think this is a mistake", "error");
                break;
        }
    }

    return root;
};
